var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcVimeo = function SvgIcVimeo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "60px",
    viewBox: "0 0 59 60",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_vimeo")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stopka",
    transform: "translate(-1631.000000, -79.000000)",
    fill: "#D5D4D3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_social",
    transform: "translate(1558.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.57,0.5 C86.54,0.5 73.6,13.76 73.6,30.17 C73.6,46.58 86.54,59.84 102.57,59.84 C118.6,59.84 131.54,46.59 131.54,30.17 C131.54,13.75 118.6,0.5 102.57,0.5 Z M100.16,49.95 C95.6,49.95 93.65,45.08 92.91,42.53 L88.08,26.46 C87.48,24.47 86.54,23.99 83.25,26.46 L81.78,24.81 C81.78,24.81 88.82,15.34 93.72,15.34 C98.62,15.34 98.81,22.68 99.42,26.87 C100.09,31.13 101.36,37.59 102.97,37.59 C104.65,37.59 109.81,30.24 109.81,26.87 C109.81,24.4 107.6,22.34 104.31,23.99 C105.446967,18.9914785 109.854402,15.4184408 114.98,15.34 C118.2,15.34 120.68,17.88 120.68,22 C120.68,32.71 105.39,49.95 100.16,49.95 L100.16,49.95 Z",
    id: "ic_vimeo"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVimeo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_vimeo.8a7b14b7.svg";
export { ForwardRef as ReactComponent };